import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import Grid from "@material-ui/core/Grid";
import moment from "moment";

import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";

import { useStyles } from "./AssignmentDetails.css";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import { publicImageUrl } from "../../../../Config/publicImageUrl";
import PdfReader from "../../../../Components/PDFReader/PdfReader";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";

class AssignmentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailData: {},
      files: [],
      pdfStatus: false,
      title: "",
      fileUrl: "",
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.getAssignmentDetails(this.props.match.params.id);
    }
  }

  getAssignmentDetails = async (assignmentId) => {
    try {
      const response = await Axios.get(
        `${url}/api/assignments/${assignmentId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.assignment) {
        this.setState({
          detailData: response.data.assignment,
          files: response.data.assignment.files,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getAssignmentDetails(assignmentId);
      }
    }
  };

  handlePdfStatus = (fileUrl, title) => {
    this.setState({
      pdfStatus: true,
      fileUrl,
      title,
    });
  };

  handleCancePdfStatus = () => {
    this.setState({
      pdfStatus: false,
    });
  };

  render() {
    const { classes } = this.props;
    const { detailData, files } = this.state;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <div style={{ fontSize: 24, fontWeight: "bold" }}>File Details</div>
          <div className={classes.listitemRoot}>
            <ListItem divider style={{ marginRight: 10 }}>
              <b style={{ flexGrow: 1 }}>Session</b>
              <div>{detailData.session}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Class</b>
              <div>{detailData.studentClass}</div>
            </ListItem>
          </div>
          <div className={classes.listitemRoot}>
            <ListItem divider style={{ marginRight: 10 }}>
              <b style={{ flexGrow: 1 }}>Faculty</b>
              <div>{detailData.faculty ? detailData.faculty : "N/A"}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Group</b>
              <div>{detailData.group ? detailData.group : "N/A"}</div>
            </ListItem>
          </div>
          <div className={classes.listitemRoot}>
            <ListItem divider style={{ marginRight: 10 }}>
              <b style={{ flexGrow: 1 }}>Title</b>
              <div>{detailData.title}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Subject</b>
              <div>{detailData.subject}</div>
            </ListItem>
          </div>
          <div className={classes.listitemRoot}>
            <ListItem divider style={{ marginRight: 10 }}>
              <b style={{ flexGrow: 1 }}>Submission Date</b>
              <div>{moment(files.submissionDate).format("LL")}</div>
            </ListItem>
            {files.length !== 0 && (
              <ListItem divider style={{ marginRight: 10 }}>
                <b style={{ flexGrow: 1 }}>Number of Assignment Files</b>
                <div>{files.length}</div>
              </ListItem>
            )}
          </div>
          {this.state.pdfStatus ? (
            <PdfReader
              fileUrl={this.state.fileUrl}
              title={this.state.title}
              handleCancelPdfStatus={this.handleCancelPdfStatus}
            />
          ) : (
            <Grid container spacing={3} className={classes.gridRoot}>
              {files.map((file, index) => (
                <Grid
                  item
                  xs={3}
                  sm={3}
                  md={2}
                  xl={2}
                  lg={2}
                  key={index}
                  className={classes.gridContent}
                  onClick={() =>
                    this.handlePdfStatus(
                      `${publicImageUrl}/${file}`,
                      `${detailData.subject}-${detailData.title}-${index + 1}`
                    )
                  }
                >
                  <InsertDriveFileIcon style={{ width: 50, height: 50 }} />
                  <div>
                    {detailData.title} - {index + 1}
                  </div>
                </Grid>
              ))}
            </Grid>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AssignmentDetails)));
